<template>
  <t-form :requiredMark="option.attribute.required" :labelAlign="option.attribute.labelAlign">
    <t-form-item :label="option.attribute.label" class="my_checkbox" :style="setStyles">
      <t-checkbox-group
        v-model="checkedVal"
        :options="options"
        @change="clickHandler"
        class="my_checkbox_item"
        :style="setStyles"
        :status="message"
      />
    </t-form-item>
      <div style="color:#c65c5d;margin-left:100px;margin-top:-20px;">{{tips}}</div>
  </t-form>
</template>

<script>
import { getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
export default {
  name: "cpt-checkbox",
  props: {
    option: Object,
    components: Array, current: Object
  },
  data() {
    return {
      options: [],
      uuid: null,
      checkedVal: null,
      newData:"",
      jsFunFlag:false,
      message: "default",
      tips: "",
    };
  },
  watch: {
    // 'option.attribute': {
    //   handler(obj) {
    //      this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
    //   },
    //   deep: true,
    // },
    "current.cptShow"(val){
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val){
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  mounted() {
  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  computed: {
    setStyles() {
      return {
        "--width": this.option.attribute.width + "px",
        "--height": this.option.attribute.height + "px",
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--brColor": this.option.attribute.brColor,
        "--activeBgColor": this.option.attribute.activeBgColor,
        "--activeBrColor": this.option.attribute.activeBrColor,
        "--activeBg": this.option.attribute.activeBg,
        "--activeColor": this.option.attribute.activeColor,
        "--textColor": this.option.attribute.textColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
      };
    },
    dataReload(){
      return this.option.attribute.globalDataReload || [0]
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        this.loadData(cptDataForm, paras);
      },this.components);
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras,(res)=> {
          that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
          that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
          that.processData(cptDataForm,that.newData,that.jsFunFlag)
        // this.options = res.options;
        // this.checkedVal = res.value;
        // if (res.value !== undefined && res.value !== "") {
        //   this.clickHandler(this.checkedVal);
        // }

      })
    },
         processData(cptDataForm,res,jsFunFlag,isFromGrid){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
                if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

            console.log(res,'res')
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
            //判断此控件在九宫格里面就不请求数据
              if(hasNonEmptyValues(this.option.attribute.cptTableData)) {
                const dataKey = this.option.attribute.cptTableData;
              // 创建一个新的数组用于存储结果
                let newres = [];
               // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
                res.forEach(item => {
                  let newItem = {};
                  dataKey.forEach(mapping => {
                    newItem[mapping.namekey] = item[mapping.value];
                  });
                  // 合并原有的键值对
                  Object.assign(newItem, item);
                  newres.push(newItem);
                });

                let newObject = {
                  value: [],
                  options: newres
                };
                 this.funselect(newObject);
                 console.log(newObject,'newObject')
              }
             } else { // 如果配置了转换脚本
                this.funselect(res);
             }
          } else { // 不是数据集类型，是静态数据
             this.funselect(res);
          } 
      },
      funselect(res) {
        this.options = res.options;
        this.checkedVal = res.value;
        if (res.value !== undefined && res.value !== "") {
          this.clickHandler(this.checkedVal);
        }
      },
    clickHandler(val) {
      setTimeout(()=>{
        this.$emit("clickHandler", this.option.interaction,val, val,"cpt-checkbox");
      },300)
       this.checkValue()
    },
       // 校验方法
    checkValue() {
      const { attribute } = this.option;
      console.log(this.checkedVal,'this.checkedVal')
      if (attribute.required && (!this.checkedVal || this.checkedVal.length == 0)) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必选`;
      
    },
    setValue(value) {
      if(value) {
        this.checkedVal = value.split(',')
      }
    },
    getValue() {
      return this.checkedVal
    }
  },
};
</script>

<style scoped>
.t-form :deep(.t-form__controls){
  margin-left: 0px !important;
}
.my_checkbox /deep/ .t-form__label {
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}
.my_checkbox_item /deep/ .t-checkbox__label{
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}

.my_checkbox_item /deep/  .t-checkbox__input {
  width: var(--width);
  height: var(--height);
  border-radius: var(--borderRadius);
  background-color: var(--bgColor);
  border-color: var(--brColor) !important;
}

.my_checkbox_item /deep/ .t-checkbox.t-is-checked .t-checkbox__label {
   color: var(--activeColor);
}

.my_checkbox_item /deep/ .t-checkbox.t-is-checked .t-checkbox__input {
    background-color: var(--activeBgColor);
    border-color: var(--activeBrColor) !important;
}

.my_checkbox_item /deep/ .t-checkbox.t-is-checked .t-checkbox__input::after {
    border-color:var(--activeBg);
    top: calc(var(--height) * 0.375);
    left: calc(var(--width) * 0.1875);
    width: calc(5 * var(--width) / 16);
    height: calc(9 * var(--height) / 16);
}
/* .t-checkbox-css /deep/ .t-checkbox__input:hover {
  border-color: var(--bgColor) !important;
}
.t-checkbox-css /deep/ .t-checkbox__input:focus {
  border-color: var(--bgColor) !important;
}
.t-checkbox-css /deep/.t-checkbox:hover {
  border-color: var(--bgColor) !important;
} */
</style>